import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { FileDown } from 'lucide-react'
import { CommunicationSettingsForm } from '@/components/settings/CommunicationSettingsForm'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { ImportModal } from '@/components/Room/ImportModal'
import { AppDispatch } from '@/redux/store'
import { getRoomDetails } from '@/redux/asyncThunks/room'

const CommunicationsSettings: React.FC = () => {
  const { roomId } = useParams<{ roomId: string }>()
  const dispatch = useDispatch<AppDispatch>()
  const [importOpen, setImportOpen] = useState<boolean>(false)

  if (!roomId) {
    return (
      <div className='p-6 text-red-700 rounded-md bg-red-50'>
        <p>Error: Room ID is required</p>
      </div>
    )
  }

  return (
    <div className='min-h-screen'>
      <div className='container px-4 py-8 mx-auto'>
        <Card className='bg-white shadow-md'>
          <CardHeader>
            <div className='flex flex-wrap gap-3 items-start justify-between'>
              <div>
                <h1 className='text-2xl font-bold text-dark-blue'>
                  Communications Settings
                </h1>
                <p className='text-gray-500'>
                  Manage email templates and communication settings for game invitations
                </p>
              </div>
              <Button
                type='button'
                variant='outline'
                className='border-dark-blue text-dark-blue hover:bg-slate-50 shrink-0'
                onClick={() => setImportOpen(true)}
              >
                <FileDown className='w-4 h-4 mr-2' />
                Import communications
              </Button>
            </div>
          </CardHeader>
          <CardContent>
            <CommunicationSettingsForm roomId={roomId} />
          </CardContent>
        </Card>
      </div>
      {importOpen && (
        <ImportModal
          key={`${roomId}-communications-import`}
          isOpen={importOpen}
          onClose={() => setImportOpen(false)}
          scope='communications'
          roomId={roomId}
          onImportComplete={() => {
            setImportOpen(false)
            void dispatch(getRoomDetails(roomId))
          }}
        />
      )}
    </div>
  )
}

export default CommunicationsSettings



